class Overlay {
    constructor (el, options) {
        const defaults = {
            loading: null,
            overlayAttr: 'data-overlay',
            overlayScrollerAttr: 'data-overlay-scroller',
            overlayCloseAttr: 'data-overlay-close',
            overlayActiveClassname: 'overlay--open'
        };
        this.settings = Object.assign({}, defaults, options);
        this.$overlay = el;
    }

    initialize () {
        this.initOverlay(this.$overlay);
    }

    freezeVp (e) {
        e.preventDefault();
    }

    stopBodyScrolling (bool, touch) {
        let eventName = 'scroll.overlay';
        if (touch === true) {
            eventName = 'touchmove.overlay';
        }

        if (bool === true) {
            document.body.addEventListener(eventName, this.freezeVp, false);
        } else {
            document.body.removeEventListener(eventName, this.freezeVp, false);
        }
    }

    removeOverlay ($layer) {
        $layer.parentNode.removeChild($layer);
    }

    openOverlay ($layer) {
        $layer.classList.add(this.settings.overlayActiveClassname);
        this.stopBodyScrolling(true, window.Modernizr.ios);
    }

    closeOverlay ($layer) {
        $layer.classList.remove(this.settings.overlayActiveClassname);

        window.setTimeout(() => {
            this.removeOverlay($layer);

            this.stopBodyScrolling(false, window.Modernizr.ios);
        }, 500);
    }

    initOverlay ($layer) {
        const $overlayClose = $layer.querySelector('[' + this.settings.overlayCloseAttr + ']');

        $overlayClose.addEventListener('click', (e) => {
            this.closeOverlay($layer);
            e.preventDefault();
        });

        this.openOverlay($layer);
    }
}

export { Overlay };
